import { PostAiClipCandidate } from './types';

export function getPostCandidateSourceMediaPostId(
  candidate: PostAiClipCandidate
): string | null {
  return candidate.sourceMediaPost?.id ?? null;
}

export function getPostCandidateOwnerId(
  candidate: PostAiClipCandidate
): string | null {
  return candidate.sourceMediaPost?.store?.id ?? null;
}

export function getPostCandidateMediaPostId(
  candidate: PostAiClipCandidate
): string | null {
  return candidate.mediaPost?.id ?? null;
}
